import { Typography, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import RTSByCarrierRTSCard from "./Cards/RTSByCarrierRTSCard.jsx";
import RTSByCarrierTotalCard from "./Cards/RTSByCarrierTotalCard.jsx";
import RTSByCarrierNotRTSCard from "./Cards/RTSByCarrierNotRTSCard.jsx";
import classes from "./Styles/ReadyToSellByCarrier.module.css";
import { useEffect, useMemo } from "react";

const ReadyToSellByCarrier = (props) => {
  let uniqueCarrierIDs = useMemo(() => [], []);
  const { agencyReadyToSellByCarrier } = useSelector(
    (state) => state.readyToSellByCarrier
  );
  const agentsNotReadyToSell = useSelector(
    (state) => state.notReadyToSell.data
  );

  useEffect(() => {
    const getUniqueCarrierIDs = () => {
      agencyReadyToSellByCarrier?.forEach((row) => {
        if (row.carrierId !== '28') {
          if (
            !uniqueCarrierIDs.includes(row.carrierId) &&
            row.carrierId !== null &&
            row.carrierId !== undefined
          ) {
            uniqueCarrierIDs.push(row.carrierId);
          }
        }
      });
    };

    if (agencyReadyToSellByCarrier && agencyReadyToSellByCarrier.length > 0) {
      getUniqueCarrierIDs();
    }
  }, [agencyReadyToSellByCarrier, uniqueCarrierIDs]);

  return (
    <>
      <Typography
        className={classes.typography}
        gutterBottom
        variant="h5"
        component="h3"
      >
        {`Approved Ready to Sell and Approved Not Ready to Sell ${
          agencyReadyToSellByCarrier && agencyReadyToSellByCarrier.length > 0
            ? ` (${agencyReadyToSellByCarrier[0].planYear})`
            : ""
        }`}
      </Typography>

      <Paper className={classes.gridContainer}>
        {agencyReadyToSellByCarrier &&
          uniqueCarrierIDs.length > 0 &&
          uniqueCarrierIDs.map((id) => (
            <>
              <RTSByCarrierTotalCard
                id={id}
                agencyReadyToSellByCarrier={agencyReadyToSellByCarrier}
              />
              <RTSByCarrierRTSCard
                id={id}
                agencyReadyToSellByCarrier={agencyReadyToSellByCarrier}
              />
              <RTSByCarrierNotRTSCard
                id={id}
                agencyReadyToSellByCarrier={agencyReadyToSellByCarrier}
                agentsNotReadyToSell={agentsNotReadyToSell}
              />
            </>
          ))}
      </Paper>
    </>
  );
};

export default ReadyToSellByCarrier;
